import { BasicBenefitsListBlock } from '../../types/optimizely/blocks/benefitsListBlock';
import { Benefit } from '../Benefit/Benefit';
import { useBenefitsListBlockData } from './useBenefitsListBlockData';
import { Carousel } from '../Carousel/Carousel';
import {
	getBackgroundColorClassName,
	getFontColorClassName,
} from '../../lib/getColorClassNames';
import { useDOMPurify } from '../../lib/useDOMPurify';

export const BenefitsListBlock = ({ contentLink }: BasicBenefitsListBlock) => {
	const data = useBenefitsListBlockData(contentLink.id);
	const sanitizedContent = useDOMPurify(data?.titleContent ?? '');

	const backgroundColorClass = getBackgroundColorClassName(
		data?.backgroundColor,
	);
	const fontColorClass = getFontColorClassName(data?.fontColor);

	return (
		<section
			className={`${backgroundColorClass} ${fontColorClass} py-16 lg:py-32`}
			id={contentLink.id}
		>
			<div
				className="container mb-12"
				dangerouslySetInnerHTML={{ __html: sanitizedContent }}
			/>
			<Carousel dataLength={data?.benefits.length} className="ml-12">
				{data?.benefits.map((benefit) => (
					<Benefit
						key={benefit.id}
						title={benefit.name}
						imageSrc={benefit.imageUrl}
						description={benefit.text}
						className={`${fontColorClass}`}
					/>
				))}
			</Carousel>
		</section>
	);
};
